<template lang="pug">
  v-flex(v-if="tabs" xs12)
    v-btn(
      v-for='(item, index) in tabs'
      :outline='tabActive != index'
      class='ma-1 d-inline-flex align-center'
      color='primary'
      small
      ripple
      @click='updateActive(index, item)'
      :key='item.label'
    )
      v-icon.mr-1(v-if="item.icon", small, left) {{ item.icon }}
      | {{ item.label }}
      span(
        v-if="!component.counterRef && tabs.length > 1"
        @click.stop="del(index)"
        style="cursor:pointer; color:#b71c1c; margin-left:4px; font-size:14px;"
      ) ×
    v-btn(
      v-if="!component.counterRef"
      @click="add"
      color="primary"
      x-small
      icon
      class="ma-1 pa-0"
      style="min-width: 20px;"
    ) +
    v-divider(class="mt-2 mb-2")
    template(v-for='(item, index) in tabs')
      div(v-show='tabActive === index')
        u-form(v-if="item.component", v-model="resultFormData", :key='item.key + index', :id='item.key' :json='item.component')
</template>

<script>
import { EventBus } from '@/event-bus'

export default {
  name: 'u-tabs',

  components: {
    UForm: () => import('@/components/form/form')
  },

  props: {
    id: {},
    formId: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    resultForm: {
      type: Object
    }
  },

  watch: {
    resultForm (val) {
      this.resultFormData = val

      if (this.component.counterRef && val[this.formId] !== val[this.component.counterRef]) {
        this.onChange(val[this.component.counterRef])
      }

      // Atualiza o localTabCount quando o resultForm mudar
      if (!this.component.counterRef && val) {
        const firstComp = this.component.components[0]
        if (firstComp && firstComp.replicate) {
          const baseKey = firstComp.key.replace('$', '_')
          const maxTabId = Object.keys(val)
            .map(key => {
              const match = key.match(new RegExp(`${baseKey}(\\d+)`))
              return match ? parseInt(match[1]) : 0
            })
            .reduce((max, current) => Math.max(max, current), 0)

          if (maxTabId > 0) {
            this.localTabCount = maxTabId
          }
        }
      }
    },
    resultFormData (val, oldVal) {
      this.$emit('update:resultForm', val)
    }
  },

  computed: {
    tabs () {
      let counterRef = this.component.counterRef || this.formId
      const firstComp = this.component.components[0]

      let numTabs = 0
      if (firstComp.replicate) {
        if (this.component.counterRef) {
          // Modo antigo: usa campo do formulário
          if (this.resultFormData[counterRef]) {
            numTabs = parseInt(this.resultFormData[counterRef])
          }
        } else {
          // Novo modo: usa estado local
          numTabs = this.localTabCount
        }

        let tabsResult = []
        if (numTabs > 0) {
          const numTabsArray = [...Array(numTabs).keys()]
          numTabsArray.forEach((item, index) => {
            let firstKey = firstComp.key.replace('$', '_' + (index + 1))
            tabsResult.push({
              label: `${this.t(this.formId + '.' + firstKey, firstComp.label)} ${index + 1}`,
              key: `${this.formId}`,
              component: {
                ...firstComp,
                key: firstKey
              }
            })
          })
        }
        return tabsResult
      }
      return []
    }
  },

  data () {
    return {
      tabActive: 0,
      eventsTrigger: [],
      resultFormData: {},
      localTabCount: 1 // Começa com uma aba aberta
    }
  },

  mounted () {
    if (this.component.events) {
      this.component.events.forEach(event => {
        if (['updateGestationFeto', 'updateGestationSaco'].indexOf(event) > -1) {
          EventBus.$on(event, this.onChange)
          if (this.eventsTrigger.indexOf(event) < 0) {
            this.eventsTrigger.push(event)
          }
        }
      })
    }
    EventBus.$on('update:tabActive', this.setTabActive)
  },

  methods: {
    add () {
      if (this.component.counterRef) {
        let counterRef = this.component.counterRef || this.formId
        let current = this.resultFormData[counterRef]
        current = current === undefined ? 0 : parseInt(current)
        const newVal = current + 1
        EventBus.$emit('eventField', { event: 'updateResultForm', val: { field: counterRef, value: newVal } })
        this.onEventTrigger(newVal)
      } else {
        this.localTabCount++
      }
    },
    del (index) {
      if (this.component.counterRef) {
        let counterRef = this.component.counterRef || this.formId
        let current = this.resultFormData[counterRef]
        if (current > 0) {
          const newVal = current - 1
          this.resultFormData = { ...this.resultFormData, [counterRef]: newVal }
        }
      } else if (this.localTabCount > 1) {
        const firstComp = this.component.components[0]
        if (firstComp && firstComp.replicate) {
          const baseKey = firstComp.key.replace('$', '_')
          const tabKey = `${baseKey}${index + 1}`

          // 1. Remove os campos da aba excluída (define como null)
          const newResultForm = { ...this.resultFormData }
          Object.keys(newResultForm).forEach(key => {
            if (key.includes(tabKey)) {
              newResultForm[key] = null
            }
          })

          // 2. Move os dados das abas posteriores para trás
          for (let i = index + 2; i <= this.localTabCount; i++) {
            const fromKey = `${baseKey}${i}`
            const toKey = `${baseKey}${i - 1}`
            Object.keys(newResultForm).forEach(key => {
              if (key.includes(fromKey)) {
                const newKey = key.replace(fromKey, toKey)
                newResultForm[newKey] = newResultForm[key]
                newResultForm[key] = null
              }
            })
          }

          this.resultFormData = newResultForm
        }

        this.localTabCount--
        // Ajusta a aba ativa se necessário
        if (this.tabActive === index) {
          this.tabActive = Math.max(0, this.tabActive - 1)
        } else if (this.tabActive > index) {
          this.tabActive--
        }
      }
    },
    onChange (val) {
      EventBus.$emit('eventField', { event: 'updateResultForm', val: { field: this.formId, value: val } })
    },
    onEventTrigger (val) {
      this.eventsTrigger.forEach(event => {
        EventBus.$emit('eventField', {event, val})
      })
    },
    setTabActive (val) {
      if (val.id !== this.id) this.tabActive = val.index
    },
    updateActive (index, item) {
      this.tabActive = index
      if (item.callback) item.callback()
      EventBus.$emit('update:tabActive', { id: this.id, index })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/layout/Tabs.vue